export const SOURCE_LOGOS = ['mithra', 'semanticVision', 'dnb'] as const;

export type SourceLogoKind = typeof SOURCE_LOGOS[number];

/** Accessible name per logo — the text the logo stands in for. */
export const SOURCE_LOGO_LABEL: Record<SourceLogoKind, string> = {
    mithra: 'Mithra',
    semanticVision: 'Semantic Vision',
    dnb: 'Dun & Bradstreet',
};

/**
 * Maps a data-source name as the API sends it (`InfoSource.name`, e.g. `"SV"`,
 * `"Dun & Bradstreet"`, `"Mithra AI enrichment"`) to its logo. `null` for anything else —
 * manual edits and unknown providers keep their text label.
 */
export function sourceLogoFromName(name: string | null | undefined): SourceLogoKind | null {
    const normalized = (name ?? '').trim().toLowerCase();
    if (!normalized) return null;
    if (normalized === 'sv' || normalized.startsWith('semantic')) return 'semanticVision';
    if (normalized === 'd&b' || normalized === 'dnb' || normalized.startsWith('dun & bradstreet') || normalized.startsWith('dun and bradstreet')) return 'dnb';
    if (normalized.startsWith('mithra')) return 'mithra';
    return null;
}
